export default "__VITE_ASSET__B0R6kAXV__"